import { render, staticRenderFns } from "./leaveclaim.vue?vue&type=template&id=458299a7"
import script from "./leaveclaim.vue?vue&type=script&lang=js"
export * from "./leaveclaim.vue?vue&type=script&lang=js"
import style0 from "./leaveclaim.vue?vue&type=style&index=0&id=458299a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports